export const normalizeToCRLF = (text = "") =>
  String(text).replace(/\r?\n/g, "\r\n");

export const buildTxtFromLines = (lines = []) => {
  const payload = Array.isArray(lines) ? lines.filter(Boolean).join("\r\n") : "";
  return normalizeToCRLF(`${payload}\r\n`);
};

export const downloadTxtFile = (filename, content) => {
  const encoded = new TextEncoder().encode(String(content ?? ""));
  const blob = new Blob([encoded], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
